// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visual-menu-main-header {
  height: 3.75rem;
  border-bottom: 1px solid var(--black1);
  padding: 1.25rem 1.5rem;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: var(--black9);
  display: flex;
  align-items: center;
  margin-bottom: 0;
  cursor: pointer;
}
.visual-menu-main-header svg {
  margin-right: 0.75rem;
}

.visual-menu-images-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.visual-menu-images-container > div {
  flex: 1 1 calc(50% - 1.5rem);
}

.visual-menu-image {
  width: 130px;
  height: 130px;
  border-radius: 0.5rem;
  border: 1px solid var(--black1);
  overflow: hidden;
  cursor: pointer;
}
.visual-menu-image-name {
  font-size: 14px;
  font-weight: 600;
}
.visual-menu-image-stats {
  color: var(--black5);
  font-size: 13px;
}
.visual-menu-image-var {
  color: var(--purple6);
  background-color: var(--purple1);
  font-size: 12px;
  padding: 0.125rem 0.375rem;
  border-radius: 6px;
  width: fit-content;
  font-family: "PT Mono", monospace;
  margin-top: 4px;
}
.visual-menu-image-wrapper {
  margin-right: -1px;
  max-width: 130px;
}
.visual-menu-image-wrapper:hover .visual-menu-image-menu {
  display: block;
}
.visual-menu-image-modal {
  width: 520px;
}
.visual-menu-image-modal .visual-menu-image-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.75rem 0;
}
.visual-menu-image-preview {
  max-width: 480px;
  border-radius: 0.5rem;
  overflow: hidden;
}
.visual-menu-image-preview img {
  object-fit: cover;
  max-width: 480px;
}
.visual-menu-image-menu {
  position: absolute;
  display: none;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 9;
}
.visual-menu-image-menu.open {
  display: block;
}
.visual-menu-image-menu .more-buttons button.square {
  width: 32px;
  min-width: 32px;
  height: 32px;
}
.visual-menu-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MuiTooltip-popper {
  z-index: 999999999 !important;
}

.visual-menu-image-dropbox {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
}
.visual-menu-image-dropbox:hover {
  background: var(--black1);
}
.visual-menu-image-dropbox.isDragAccept {
  border-color: var(--green6);
  background: var(--green0);
}
.visual-menu-image-dropbox.isDragReject {
  border-color: var(--red6);
  background: var(--red0);
}
.visual-menu-image-dropbox.isFocused {
  border-color: var(--purple6);
}

.visual-menu-image-new {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 110px;
  border-radius: 0.5rem;
  border: 1px solid var(--black1);
  cursor: pointer;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black6);
}
.visual-menu-image-new svg {
  margin-bottom: 0.75rem;
}
.visual-menu-image-new:hover {
  border-color: var(--black2);
}

.visual-menu-main-footer {
  height: 3.75rem;
  border-top: 1px solid var(--black1);
  padding: 1.25rem 1.5rem;
  color: var(--black9);
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}
.visual-menu-main-footer.delete {
  color: var(--red6);
}
.visual-menu-main-footer svg {
  margin-right: 0.75rem;
}

.visual-menu-divider {
  margin: 0.5rem 0;
  border-bottom: 1px solid var(--black1);
}

.visual-menu-content {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.visual-menu-main-body {
  position: relative;
  overflow: auto;
  flex: 1;
}
.visual-menu-main-body::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: transparent;
}
.visual-menu-main-body::-webkit-scrollbar-track {
  background-color: transparent;
}
.visual-menu-main-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}

.visual-menu-block-add {
  display: flex;
  align-items: center;
  width: 100%;
  color: var(--purple6);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  height: 3.25rem;
  padding: 0 2rem 0 3.5rem;
  justify-content: space-between;
}
.visual-menu-block-add svg {
  margin-right: 0.75rem;
}

.visual-menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}
.visual-menu-icon svg {
  margin-right: 0 !important;
}
.visual-menu-icon.delete-icon svg * {
  stroke: var(--red6);
}

.visual-menu-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid var(--black1);
}
.visual-menu-block.draggable {
  height: 2.5rem;
  padding: 0.5rem 0;
  overflow: hidden;
  outline: none;
  border: none;
  background: var(--purple1) !important;
}
.visual-menu-block:last-child {
  border-bottom: none;
}
.visual-menu-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.75rem;
  padding: 0 1rem 0 3.5rem;
  cursor: pointer;
}
.visual-menu-block-header #buttons {
  display: none !important;
}
.visual-menu-block-header:hover {
  background: var(--black1);
}
.visual-menu-block-header:hover #buttons {
  display: flex !important;
}
.visual-menu-block-header svg {
  margin-right: 0.75rem;
  cursor: pointer;
}
.visual-menu-block-header-title {
  min-width: 0;
  max-width: 100%;
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  text-transform: capitalize;
}

.visual-menu-block-title {
  min-width: 0;
  max-width: 100%;
  width: 100%;
  color: var(--black9);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
}

.visual-menu-settings-header {
  height: 3.75rem;
  display: flex;
  align-items: center;
  padding: 0 1.25rem 0 1.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  border-bottom: 1px solid var(--black1);
  text-transform: capitalize;
  cursor: pointer;
}
.visual-menu-settings-content {
  padding: 0.5rem 2rem;
}
.visual-menu-settings-content-no {
  color: var(--red6);
}
.visual-menu-settings-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.visual-menu-settings-subtitle {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
  color: var(--black9);
}
.visual-menu-settings-picker {
  display: flex;
  margin-bottom: 0.75rem;
}
.visual-menu-settings-picker-color {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
  margin-right: 0.75rem;
  cursor: pointer;
  border: 1px solid var(--black0);
}
.visual-menu-settings-picker-label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
}
.visual-menu-settings-picker-value {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: var(--black5);
}

.image-gallery .visual-menu-image-new {
  flex-basis: 100%;
  border-style: dashed;
  height: 136px;
}
.image-gallery .visual-menu-images-container {
  padding: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/screens/visual/menu.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,sCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;;AAGA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAAF;AAEE;EACE,4BAAA;AAAJ;;AAIA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,oBAAA;EACA,eAAA;AAFJ;AAKE;EACE,qBAAA;EACA,gCAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;AAJJ;AAQI;EACE,cAAA;AANN;AAUE;EACE,YAAA;AARJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAPN;AAWE;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AATJ;AAUI;EACE,iBAAA;EACA,gBAAA;AARN;AAYE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAVJ;AAYI;EACE,cAAA;AAVN;AAaM;EACE,WAAA;EACA,eAAA;EACA,YAAA;AAXR;AAgBE;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE,6BAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAhBF;AAkBE;EACE,yBAAA;AAhBJ;AAmBE;EACE,2BAAA;EACA,yBAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,uBAAA;AAlBJ;AAqBE;EACE,4BAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,+BAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AApBF;AAsBE;EACE,sBAAA;AApBJ;AAuBE;EACE,2BAAA;AArBJ;;AAyBA;EACE,eAAA;EACA,mCAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvBF;AAyBE;EACE,kBAAA;AAvBJ;AA0BE;EACE,qBAAA;AAxBJ;;AA4BA;EACE,gBAAA;EACA,sCAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,cAAA;EACA,OAAA;AAzBF;AA2BE;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AAzBJ;AA2BI;EACE,6BAAA;AAzBN;AA4BI;EACE,oCAAA;AA1BN;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,8BAAA;AA5BF;AA8BE;EACE,qBAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA7BF;AA+BE;EACE,0BAAA;AA7BJ;AAiCI;EACE,mBAAA;AA/BN;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sCAAA;AAjCF;AAmCE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,qCAAA;AAjCJ;AAoCE;EACE,mBAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AAnCJ;AAqCI;EACE,wBAAA;AAnCN;AAsCI;EACE,yBAAA;AApCN;AAsCM;EACE,wBAAA;AApCR;AAwCI;EACE,qBAAA;EACA,eAAA;AAtCN;AAyCI;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;AAvCN;;AA4CA;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAzCF;;AA8CE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sCAAA;EACA,0BAAA;EACA,eAAA;AA3CJ;AA8CE;EACE,oBAAA;AA5CJ;AA8CI;EACE,kBAAA;AA5CN;AAgDE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA9CJ;AAiDE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AA/CJ;AAkDE;EACE,aAAA;EACA,sBAAA;AAhDJ;AAkDI;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,+BAAA;AAhDN;AAmDI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAjDN;AAoDI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAlDN;;AAyDE;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;AAtDJ;AAwDE;EACE,eAAA;AAtDJ","sourcesContent":[".visual-menu-main-header {\n  height: 3.75rem;\n  border-bottom: 1px solid var(--black1);\n  padding: 1.25rem 1.5rem;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  color: var(--black9);\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  cursor: pointer;\n\n  svg {\n    margin-right: .75rem;\n  }\n}\n\n.visual-menu-images-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: .75rem;\n\n  & > div {\n    flex: 1 1 calc((100% / 2) - 1.5rem);\n  }\n}\n\n.visual-menu-image {\n  width: 130px;\n  height: 130px;\n  border-radius: .5rem;\n  border: 1px solid var(--black1);\n  overflow: hidden;\n  cursor: pointer;\n\n  &-name {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  &-stats {\n    color: var(--black5);\n    font-size: 13px;\n  }\n\n  &-var {\n    color: var(--purple6);\n    background-color: var(--purple1);\n    font-size: 12px;\n    padding: 0.125rem 0.375rem;\n    border-radius: 6px;\n    width: fit-content;\n    font-family: 'PT Mono', monospace;\n    margin-top: 4px;\n  }\n\n  &-wrapper {\n    margin-right: -1px;\n    max-width: 130px;\n  }\n\n  &-wrapper:hover {\n    .visual-menu-image-menu {\n      display: block;\n    }\n  }\n\n  &-modal {\n    width: 520px;\n    & &-body {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 3.75rem 0;\n    }\n  }\n\n  &-preview {\n    max-width: 480px;\n    border-radius: .5rem;\n    overflow: hidden;\n    img {\n      object-fit: cover;\n      max-width: 480px;\n    }\n  }\n\n  &-menu {\n    position: absolute;\n    display: none;\n    top: 0.5rem;\n    right: 0.5rem;\n    z-index: 9;\n\n    &.open {\n      display: block;\n    }\n    .more-buttons {\n      button.square {\n        width: 32px;\n        min-width: 32px;\n        height: 32px;\n      }\n    }\n  }\n\n  img {\n    //border-radius: .5rem;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.MuiTooltip-popper {\n  z-index: 999999999 !important;\n}\n\n.visual-menu-image-dropbox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: .5rem;\n\n  &:hover {\n    background: var(--black1);\n  }\n\n  &.isDragAccept {\n    border-color: var(--green6);\n    background: var(--green0);\n  }\n\n  &.isDragReject {\n    border-color: var(--red6);\n    background: var(--red0);\n  }\n\n  &.isFocused {\n    border-color: var(--purple6);\n  }\n}\n\n.visual-menu-image-new {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 110px;\n  height: 110px;\n  border-radius: .5rem;\n  border: 1px solid var(--black1);\n  cursor: pointer;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--black6);\n\n  svg {\n    margin-bottom: .75rem;\n  }\n\n  &:hover {\n    border-color: var(--black2);\n  }\n}\n\n.visual-menu-main-footer {\n  height: 3.75rem;\n  border-top: 1px solid var(--black1);\n  padding: 1.25rem 1.5rem;\n  color: var(--black9);\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n\n  &.delete {\n    color: var(--red6);\n  }\n\n  svg {\n    margin-right: .75rem;\n  }\n}\n\n.visual-menu-divider {\n  margin: .5rem 0;\n  border-bottom: 1px solid var(--black1);\n}\n\n.visual-menu-content {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n}\n\n.visual-menu-main-body {\n  position: relative;\n  overflow: auto;\n  flex: 1;\n\n  &::-webkit-scrollbar {\n    width: 2px;\n    height: 2px;\n    background-color: transparent;\n\n    &-track {\n      background-color: transparent;\n    }\n\n    &-thumb {\n      background-color: rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n.visual-menu-block-add {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: var(--purple6);\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  height: 3.25rem;\n  padding: 0 2rem 0 3.5rem;\n  justify-content: space-between;\n\n  svg {\n    margin-right: .75rem;\n  }\n}\n\n.visual-menu-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  cursor: pointer;\n\n  svg {\n    margin-right: 0 !important;\n  }\n\n  &.delete-icon {\n    svg * {\n      stroke: var(--red6);\n    }\n  }\n}\n\n.visual-menu-block {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-bottom: 1px solid var(--black1);\n\n  &.draggable {\n    height: 2.5rem;\n    padding: .5rem 0;\n    overflow: hidden;\n    outline: none;\n    border: none;\n    background: var(--purple1) !important;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 2.75rem;\n    padding: 0 1rem 0 3.5rem;\n    cursor: pointer;\n\n    #buttons {\n      display: none !important;\n    }\n\n    &:hover {\n      background: var(--black1);\n\n      #buttons {\n        display: flex !important;\n      }\n    }\n\n    svg {\n      margin-right: .75rem;\n      cursor: pointer;\n    }\n\n    &-title {\n      min-width: 0;\n      max-width: 100%;\n      width: 100%;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      text-transform: capitalize;\n    }\n  }\n}\n\n.visual-menu-block-title {\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n  color: var(--black9);\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  text-transform: capitalize;\n}\n\n\n.visual-menu-settings {\n  &-header {\n    height: 3.75rem;\n    display: flex;\n    align-items: center;\n    padding: 0 1.25rem 0 1.5rem;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--black9);\n    border-bottom: 1px solid var(--black1);\n    text-transform: capitalize;\n    cursor: pointer;\n  }\n\n  &-content {\n    padding: .5rem 2rem;\n\n    &-no {\n      color: var(--red6);\n    }\n  }\n\n  &-title {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--black9);\n  }\n\n  &-subtitle {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    margin-bottom: 1rem;\n    margin-top: 1.5rem;\n    color: var(--black9);\n  }\n\n  &-picker {\n    display: flex;\n    margin-bottom: .75rem;\n\n    &-color {\n      width: 2.5rem;\n      height: 2.5rem;\n      border-radius: 100%;\n      margin-right: .75rem;\n      cursor: pointer;\n      border: 1px solid var(--black0)\n    }\n\n    &-label {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 13px;\n      line-height: 16px;\n      color: var(--black9);\n    }\n\n    &-value {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 16px;\n      color: var(--black5);\n    }\n\n  }\n}\n\n.image-gallery {\n  .visual-menu-image-new {\n    flex-basis: 100%;\n    border-style: dashed;\n    height: 136px;\n  }\n  .visual-menu-images-container {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
